import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileCardList, MobileCardField } from '../../../../shared/mobile/ResponsiveTable';
import { FavoriteStar } from '../../../../ui/FavoriteStar';
import { UtilizationProductRow, UnmappedProductRow } from '../../../../../utils/reports/utilizationReport';
import { fmtBase } from '../../../../../utils/reports/shared';
import { eur } from '../../../../orderhistory/utils';
import { pctAbs, EmptyCard } from '../common';

export const OrganizationUtilizationMobileRows: React.FC<{
  rows: UtilizationProductRow[];
  unmappedRows: UnmappedProductRow[];
  unmapped: boolean;
  favoriteKeys: string[];
  favoriteDisabled: (key: string) => boolean;
  onToggleFavorite: (key: string) => void;
  onOpen: (key: string) => void;
}> = ({ rows, unmappedRows, unmapped, favoriteKeys, favoriteDisabled, onToggleFavorite, onOpen }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(20);
  const items: Array<UtilizationProductRow | UnmappedProductRow> = unmapped ? unmappedRows : rows;
  if (!items.length) return <EmptyCard message={t('reports.utilization.organization.noMatches')} />;
  return <MobileCardList items={items.slice(0, visible)} keyOf={row => row.key}
    onLoadMore={() => setVisible(n => n + 20)} hasMore={items.length > visible} loadMoreLabel={t('common.loadMore')}
    renderCard={row => <div className="rounded-xl p-4 bg-background dark:bg-background-dark text-textPrimary dark:text-textPrimary-dark">
      <div className="flex items-center gap-2">
        {!unmapped && <FavoriteStar isFavorite={favoriteKeys.includes(row.key)} disabled={favoriteDisabled(row.key)} onToggle={() => onToggleFavorite(row.key)} />}
        <button type="button" className="font-semibold text-left" onClick={() => onOpen(row.key)}>{row.name}</button>
      </div>
      <span className="block text-sm mb-2">{row.supplier}</span>
      {'orderedBase' in row ? <div className="grid grid-cols-2 gap-3">
        <MobileCardField label={t('reports.utilization.col.ordered')} value={fmtBase(row.orderedBase, row.stdUnit)} />
        <MobileCardField label={t('reports.utilization.col.needed')} value={fmtBase(row.neededBase, row.stdUnit)} />
        <MobileCardField label={t('reports.utilization.col.utilization')} value={row.utilizationPercent === null ? '—' : pctAbs(row.utilizationPercent)} />
        <MobileCardField label={t('reports.utilization.col.wasteEur')} value={row.wasteEur === null ? '—' : eur(row.wasteEur)} />
      </div> : <MobileCardField label={t('reports.utilization.col.spend')} value={eur(row.spend)} />}
      <button type="button" className="mt-2 text-sm underline" onClick={() => onOpen(row.key)}>{t('reports.utilization.organization.breakdown')}</button>
    </div>} />;
};
